const specs = {
  width: 620,
  title: {
    update: 'pages.predictableRisks.modal.update.single.title',
    create: 'pages.predictableRisks.modal.create.single.title'
  },
  okText: {
    update: 'pages.predictableRisks.modal.update.single.okText',
    create: 'pages.predictableRisks.modal.create.single.okText'
  },
  actions: {
    delete: {
      buttonType: 'danger'
    }
  },
  rows: {
    name: {
      title: 'pages.predictableRisks.fields.name.title',
      dataIndex: 'name',
      key: 'name',
      formField: {
        label: 'pages.predictableRisks.fields.name.title',
        required: 'pages.predictableRisks.fields.name.requiredMessage',
        placeholder: 'pages.predictableRisks.fields.name.placeholder'
      },
      empty: 'common.unknown.male'
    }
  }
}

export default specs
